import { render, staticRenderFns } from "./UserModules.vue?vue&type=template&id=17a06766&"
import script from "./UserModules.vue?vue&type=script&lang=ts&"
export * from "./UserModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports